export default __webpack_public_path__ + "static/media/t3.e3225e4c.jpg";